/**
 * Created by razial on 18.09.2026.
 */

Mission.TYPE_SALEPASS = 25;

Forces.SALEPASS_FORCE = {
    controls: ["toolbar"],
    target: function () {
        return cleverapps.toolbar.getItem(ToolbarItem.UNIT_SHOP.type).onGetView();
    },
    finger: {
        delay: true
    }
};

Mission.REGISTRATIONS.set(Mission.TYPE_SALEPASS, () => ({
    ...BaseMissionData(),
    name: "SalePass",
    view: SalePassWindow,
    semaphore: Mission.SEMAPHORE_PRIMARY,
    startWindow: SalePassWindow,
    finishWindow: SalePassWindow,
    guideWindow: SalePassRulesOptions,
    logic: PassMissionLogic,
    levels: PassLevelsConfig.salepass,
    sideBarJson: bundles.sidebar.jsons.salepass_icon_json,
    lastChanceView: PassLastChanceWindow,
    collectIcon: bundles.reward_icons_pass.frames.pass_coin_png,
    collectItemName: "crystal",
    ticketJson: "purchase_ticket_json",
    taskPointCompleted: "sale_task_point_completed",
    eventPrefix: "purchase",
    duration: "3 days",
    cooldown: "28 days",
    tutorial: MergeTutorials.salepass,
    unit: { code: "discountshop", stage: 0 },
    disabledNewMission: true,
    available: cleverapps.config.availables.SALEPASS_MISSION
}));
